// extracted by mini-css-extract-plugin
export var focus = "side-block-module--focus--0530b";
export var hover = "side-block-module--hover--ef96f";
export var image = "side-block-module--image--ec727";
export var important = "side-block-module--important--361ec";
export var link = "side-block-module--link--89e88";
export var secondaryBlock = "side-block-module--secondaryBlock--cc188";
export var svgImage = "side-block-module--svgImage--13e4f";